import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mobile/ship.png'
import _imports_1 from '@/assets/images/veles.png'
import _imports_2 from '@/assets/svg/about/10.svg'
import _imports_3 from '@/assets/svg/about/3.svg'
import _imports_4 from '@/assets/svg/about/100.svg'
import _imports_5 from '@/assets/images/about/adamovich.png'
import _imports_6 from '@/assets/images/about/mosk.png'
import _imports_7 from '@/assets/images/about/sved.png'
import _imports_8 from '@/assets/images/about/nefed.png'
import _imports_9 from '@/assets/images/about/award_1.png'
import _imports_10 from '@/assets/images/about/award_2.png'
import _imports_11 from '@/assets/images/about/award_3.png'
import _imports_12 from '@/assets/images/about/award_4.png'
import _imports_13 from '@/assets/images/about/award_5.png'
import _imports_14 from '@/assets/images/about/award_6.png'
import _imports_15 from '@/assets/images/about/award_7.png'
import _imports_16 from '@/assets/images/about/award_8.png'


const _hoisted_1 = { class: "relative mt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-[111px] right-[10px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-[200px]"
  })
], -1)
const _hoisted_3 = { class: "flex flex-col gap-y-5 items-center justify-center py-3 max-w-[250px] mx-auto mb-12" }
const _hoisted_4 = { class: "flex flex-col gap-y-5 px-6 mb-[60px]" }
const _hoisted_5 = { class: "px-[29px]" }
const _hoisted_6 = { class: "px-[52px]" }
const _hoisted_7 = { class: "px-[75px]" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-[101px] mb-12"
  })
], -1)
const _hoisted_9 = { class: "flex flex-col items-center justify-center gap-y-8 mb-12" }
const _hoisted_10 = { class: "h-[112px] w-[116px] flex flex-col items-center justify-center border border-[var(--primary-color)] rounded-full px-[10px]" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-10"
}, null, -1)
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "h-[132px] w-[148px] flex flex-col items-center justify-center border border-[var(--primary-color)] rounded-full px-[10px]" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-10"
}, null, -1)
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "h-[140px] w-[156px] flex flex-col items-center justify-center border border-[var(--primary-color)] rounded-full px-[10px]" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "w-[100px]"
}, null, -1)
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "flex flex-col gap-y-6 px-[56px] py-4 mb-12" }
const _hoisted_20 = { class: "grid grid-cols-[24px_auto] gap-x-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_22 = { class: "max-w-[250px]" }
const _hoisted_23 = { class: "grid grid-cols-[24px_auto] gap-x-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_25 = { class: "max-w-[250px]" }
const _hoisted_26 = { class: "grid grid-cols-[24px_auto] gap-x-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-6 bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_28 = { class: "max-w-[250px]" }
const _hoisted_29 = { class: "grid grid-cols-[24px_auto] gap-x-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_31 = { class: "max-w-[250px]" }
const _hoisted_32 = { class: "grid grid-cols-[24px_auto] gap-x-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_34 = { class: "max-w-[250px]" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "h-[6px] bg-[var(--secondary-color)] mb-[60px]" }, null, -1)
const _hoisted_36 = { class: "px-6 mb-12" }
const _hoisted_37 = { class: "flex flex-col" }
const _hoisted_38 = { class: "p-3 mb-12" }
const _hoisted_39 = { class: "border-[3px] border-[var(--primary-color)] rounded-[50px] py-[20px] mb-12" }
const _hoisted_40 = { class: "flex items-center justify-center" }
const _hoisted_41 = { class: "py-[10px] pl-[60px] pr-[40px]" }
const _hoisted_42 = { class: "list-disc" }
const _hoisted_43 = { class: "border-[3px] border-[var(--primary-color)] rounded-[50px] py-[20px]" }
const _hoisted_44 = { class: "flex items-center justify-center" }
const _hoisted_45 = { class: "py-[10px] pl-[60px] pr-[40px]" }
const _hoisted_46 = { class: "list-disc" }
const _hoisted_47 = { class: "flex flex-col px-6" }
const _hoisted_48 = { class: "p-3 mb-12" }
const _hoisted_49 = { class: "relative flex flex-col items-center justify-center gap-y-10 px-[52px] py-[50px] bg-[var(--primary-color)] w-full mb-[64px]" }
const _hoisted_50 = { class: "flex flex-col gap-y-5" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "w-[236px]"
}, null, -1)
const _hoisted_52 = { class: "flex flex-col items-center gap-y-1" }
const _hoisted_53 = { class: "p-[10px] text-center" }
const _hoisted_54 = { class: "flex flex-col gap-y-5" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "w-[236px]"
}, null, -1)
const _hoisted_56 = { class: "flex flex-col items-center gap-y-1" }
const _hoisted_57 = { class: "p-[10px] text-center" }
const _hoisted_58 = { class: "flex flex-col gap-y-5" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "w-[236px]"
}, null, -1)
const _hoisted_60 = { class: "flex flex-col items-center gap-y-1" }
const _hoisted_61 = { class: "p-[10px] text-center" }
const _hoisted_62 = { class: "flex flex-col gap-y-5" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "w-[236px]"
}, null, -1)
const _hoisted_64 = { class: "flex flex-col items-center gap-y-1" }
const _hoisted_65 = { class: "p-[10px] text-center" }
const _hoisted_66 = { class: "flex flex-col px-6" }
const _hoisted_67 = { class: "p-3 mb-12" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-2 items-center gap-x-6 gap-y-6 mb-[64px] justify-items-center\"><img src=\"" + _imports_9 + "\" class=\"w-[116px]\"><img src=\"" + _imports_10 + "\" class=\"w-[116px]\"><img src=\"" + _imports_11 + "\" class=\"w-[116px]\"><img src=\"" + _imports_12 + "\" class=\"w-[116px]\"><img src=\"" + _imports_13 + "\" class=\"w-[116px]\"><img src=\"" + _imports_14 + "\" class=\"w-[116px]\"><img src=\"" + _imports_15 + "\" class=\"w-[116px]\"><img src=\"" + _imports_16 + "\" class=\"w-[116px]\"></div>", 1)

import BaseReturn from '@/components/common/BaseReturn.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index2',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(BaseReturn, {
      text: _unref(t)('about.title')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseTypography, {
        text: _unref(t)('about.text.first'),
        type: "body-m"
      }, null, 8, ["text"]),
      _createVNode(BaseTypography, {
        text: _unref(t)('about.text.second'),
        type: "body-m"
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseTypography, {
          text: _unref(t)('about.tagline.text-1.first'),
          type: "headline-m",
          tag: "span",
          color: "var(--primary-color)"
        }, null, 8, ["text"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('about.tagline.text-1.second'),
          type: "headline2-m",
          tag: "span",
          color: "var(--black-color)"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseTypography, {
          text: _unref(t)('about.tagline.text-2.first'),
          type: "headline-m",
          tag: "span",
          color: "var(--primary-color)"
        }, null, 8, ["text"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('about.tagline.text-2.second'),
          type: "headline2-m",
          tag: "span",
          color: "var(--black-color)"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseTypography, {
          text: _unref(t)('about.tagline.text-3.first'),
          type: "headline-m",
          tag: "span",
          color: "var(--primary-color)"
        }, null, 8, ["text"]),
        _createVNode(BaseTypography, {
          text: _unref(t)('about.tagline.text-3.second'),
          type: "headline2-m",
          tag: "span",
          color: "var(--black-color)"
        }, null, 8, ["text"])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.labels.years'),
            type: "body3-m"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.labels.direction'),
            type: "body3-m"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.labels.success'),
            type: "body3-m"
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-1.first'),
            type: "body-m",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-1.second'),
            type: "body2-m",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-1.third'),
            type: "body-m",
            tag: "span"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-2.first'),
            type: "body-m",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-2.second'),
            type: "body2-m",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-2.third'),
            type: "body-m",
            tag: "span"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-3.first'),
            type: "body-m",
            tag: "span"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('about.list.text-3.second'),
            type: "body2-m",
            tag: "span"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_router_link, { to: "/categories" }, {
            default: _withCtx(() => [
              _createVNode(BaseTypography, {
                text: "туры по Санкт-Петербургу и России,",
                type: "body-m",
                class: "underline"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_router_link, { to: "/excursions" }, {
            default: _withCtx(() => [
              _createVNode(BaseTypography, {
                text: "экскурсии и мероприятия (конференции, свадьбы и др.) в Санкт-Петербурге",
                type: "body-m",
                class: "underline"
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_35,
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.guarantee.title'),
            type: "subtitle-m"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.guarantee.clients.title'),
              type: "body-m",
              color: "var(--primary-color)"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("ul", _hoisted_42, [
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.first'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.second'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.third'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.fourth'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.guarantee.partners.title'),
              type: "body-m",
              color: "var(--primary-color)"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("ul", _hoisted_46, [
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.first'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.second'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.third'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.fourth'),
                  type: "body3-m"
                }, null, 8, ["text"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.team.title'),
            type: "subtitle-m"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.first.post'),
                type: "body3-m",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.first.name'),
              type: "title2-m",
              color: "var(--base-white)"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.second.post'),
                type: "body3-m",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.second.name'),
              type: "title2-m",
              color: "var(--base-white)"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.third.post'),
                type: "body3-m",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.third.name'),
              type: "title2-m",
              color: "var(--base-white)"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.fourth.post'),
                type: "body3-m",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.fourth.name'),
              type: "title2-m",
              color: "var(--base-white)"
            }, null, 8, ["text"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createVNode(BaseTypography, {
          text: _unref(t)('about.awards.title'),
          type: "subtitle-m"
        }, null, 8, ["text"])
      ]),
      _hoisted_68
    ])
  ]))
}
}

})